export enum InteractionType {
  None,
  Paint,
  Drop,
  Erase,
}
